function ConvertDate(dbdate) {
    if (!dbdate || dbdate === '-' || isNaN(Date.parse(dbdate))) return '-';
    const dt = new Date(Date.parse(dbdate));
    return dt.toLocaleDateString();
}

export default ConvertDate;